











































import {Component, Prop, Vue} from 'vue-property-decorator'
import ThemesStore from "@/store/modules/ThemesStore";
import ThemeVariableStore from "@/store/modules/ThemeVariableStore";
import SettingOptionUI from "@/components/UI/SettingOptionUI.vue";
import ThemeCategory from "@/pages/DesignPage/ThemeCategory.vue";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";

@Component({
    components: {
        ThemeCategory,
        SettingOptionUI,
    },
})
export default class DesignSettingBar extends Vue {
    get pageName(): string {
        return this.$route.params["pageName"] || "";
    }

    get page(): CMS.Page {
        return ThemesStore.selectedThemePageByName[this.pageName] || {};
    }

    get settingOptions(): CMS.SettingOption[] {
        return this.page.options || [];
    }

    get categories(): CMS.Category[] {
        return CategoriesStore.all
    }

    get themeCategorySettingOptions(): CMS.SettingOption[] {
        const settingOptions: CMS.SettingOption[] = ThemesStore.selectedTheme.theme_category_options;
        if (!settingOptions)
            return [];

        return settingOptions.filter(v => v.edit_page_name == this.pageName);
    }

    get enableThemeCategorySetting(): boolean {
        console.log(this.pageName, this.themeCategorySettingOptions, this.themeCategorySettingOptions.length);
        return this.themeCategorySettingOptions.length > 0;
    }

    // CMSで編集済みの値を返却
    private getEditedOptionValue(optionName: string): any {
        const themeValue: CMS.ThemeSettingValue = ThemeVariableStore.all.value;
        if (!themeValue)
            return null;

        const pageValue: any = themeValue.pages[this.pageName];
        if (!pageValue)
            return null;

        return pageValue[optionName];
    }

    private onChange(option: string, value: string) {
        ThemeVariableStore.localEdit({page: this.pageName, option: option, value: value});
    }

}
